<template>
    <div class="input-group">
        <span v-if="showIcon === undefined || showIcon" class="input-group-text">
            <svg :width="iconSize" :height="iconSize" fill="currentColor">
                <use :xlink:href="'/assets/icons/bootstrap-icons.svg#' + icon" />
            </svg>
        </span>
        <input
            :type="inputType"
            class="form-control"
            :placeholder="placeholder"
            :multiple="multiple"
            autocomplete="off"
            @input="$emit('update:modelValue', $event.target.value)"
            @keyup="$emit('keyup')"
            @blur="$emit('blur')"
            @change="$emit('onChange', $event)"
        />
    </div>
</template>


<script>
    export default {
        name: 'InputField',
        props: {
            showIcon: {
                type: Boolean,
                default: false,
            },
            icon: {
                type: String,
                default: "info",
            },
            iconSize: {
                type: Number,
                default: 20,
            },
            inputType: {
                type: String,
                default: "text",
            },
            placeholder: {
                type: String,
                default: "",
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        setup() {},
    };
</script>